// import Select from 'react-select';
// import { useEffect, useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// // ✅ السلايس
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
// // ✅ المكونات
// import ReportPagination from './ReportPagination';
// // ✅ Hooks الخيارات
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// // ✅ Item/UOM Picker
// import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';
// import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
// import ReportExportExcelModal, { type ExportColumn } from './ReportExportExcelModal';

// type RowDto = {
//   itemId: string;
//   itemCode: string;
//   itemType: string;
//   taxCtegory: string;
//   itemName: string;
//   itemName2: string;
//   categoryId: string;
//   categoryName: string;
//   categoryName2: string;
//   uomId: string;
//   uomCode: string;
//   uomName: string;
//   uomName2: string;
//   uomClass: string;
//   brandId: string | null;
//   brandName: string | null;
//   brandName2: string | null;
//   invId: string;
//   invCode: string;
//   invName: string;
//   invName2: string;
//   ouId: string;
//   ouCode: string;
//   ouName: string;
//   ouName2: string;
//   costPrice: number;
//   quantity: number;
//   total: number;
//   avgCostSimple: number | null;
//   avgCostPrice: number | null;
// };

// const REPORT_KEY = 'RPT_InventoryValuation';
// const ENDPOINT = 'InventoryReports/GetInventoryValuationPaged';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));
// const n0 = (v: any) => (v === null || v === undefined || Number.isNaN(Number(v)) ? 0 : Number(v));
// const formatNumber = (num: number, digits: number = 2) => {
//   return new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: digits,
//     maximumFractionDigits: digits
//   }).format(num);
// };
// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const RPT_InventoryValuation = () => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // options
//   const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loadingInventoryOptions } = useGetInventoryWithPermission();

//   // ✅ Item & UOM Picker
//   const { pickItemUom, modalProps } = useItemUomPicker();
//   const [pickedItem, setPickedItem] = useState<ItemWithUomRow | null>(null);
//   const [itemId, setItemId] = useState<string | null>(null);

//   // ✅ فلتر Only With Qty (جديد)
//   const [onlyWithQty, setOnlyWithQty] = useState<boolean>(true);

//   // Export Excel
//   const [showExport, setShowExport] = useState(false);

//   const exportColumns: ExportColumn<RowDto>[] = [
//     {
//       headerAr: 'الصنف',
//       headerEn: 'Item',
//       value: (r, ctx) => (ctx.isAr ? (r.itemName2 ?? r.itemName) : (r.itemName ?? r.itemName2))
//     },
//     { headerAr: 'الكود', headerEn: 'Code', value: r => r.itemCode ?? '' },
//     {
//       headerAr: 'التصنيف',
//       headerEn: 'Category',
//       value: (r, ctx) => (ctx.isAr ? (r.categoryName2 ?? r.categoryName) : (r.categoryName ?? r.categoryName2))
//     },
//     {
//       headerAr: 'الوحدة',
//       headerEn: 'UOM',
//       value: (r, ctx) => (ctx.isAr ? (r.uomName2 ?? r.uomName) : (r.uomName ?? r.uomName2))
//     },
//     {
//       headerAr: 'المخزن',
//       headerEn: 'Inventory',
//       value: (r, ctx) => (ctx.isAr ? (r.invName2 ?? r.invName) : (r.invName ?? r.invName2))
//     },
//     {
//       headerAr: 'وحدة التشغيل',
//       headerEn: 'Operating Unit',
//       value: (r, ctx) => (ctx.isAr ? (r.ouName2 ?? r.ouName) : (r.ouName ?? r.ouName2))
//     },
//     { headerAr: 'التكلفة', headerEn: 'Cost', value: r => r.costPrice ?? 0 },
//     { headerAr: 'الكمية', headerEn: 'Qty', value: r => r.quantity ?? 0 },
//     { headerAr: 'الإجمالي', headerEn: 'Total', value: r => r.total ?? 0 }
//   ];

//   // local filters UI state
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [inventoryFilter, setInventoryFilter] = useState<any>(null);
//   const [showFilters, setShowFilters] = useState(false);

//   const selectedInventoryId = useMemo(() => getOptId(inventoryFilter), [inventoryFilter]);

//   // report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;
//   const isAr = i18n.language !== 'en';

//   const activeFiltersCount = useMemo(() => {
//     let c = 0;
//     if (branchFilter) c++;
//     if (inventoryFilter) c++;
//     if (itemId) c++;
//     if (!onlyWithQty) c++; // إذا تم إلغاء التحديد = فلتر نشط (عرض الأصناف بدون كمية)
//     return c;
//   }, [branchFilter, inventoryFilter, itemId, onlyWithQty]);

//   useEffect(() => {
//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest: {
//           pageIndex: 0,
//           pageSize: 50,
//           onlyWithQty: true
//         }
//       })
//     );
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   }, [dispatch]);

//   // ==========================
//   // Item Picker helpers
//   // ==========================
//   const getPickedItemLabel = (r: ItemWithUomRow | null) => {
//     if (!r) return '';
//     const name = isAr ? r.name2 || r.name : r.name || r.name2;
//     const code = r.itemCode ?? '';
//     return `${code} - ${name ?? ''}`.trim();
//   };

//   const clearPickedItem = () => {
//     setPickedItem(null);
//     setItemId(null);
//   };

//   const openItemPicker = async () => {
//     const res = await pickItemUom({
//       title: isAr ? 'اختيار صنف ووحدة' : 'Select Item & UOM',
//       params: {
//         InventoryId: selectedInventoryId || undefined,
//         WithParent: true,
//         WithImage: false,
//         WithLots: false,
//         OnlyEnabled: true
//       } as any,
//       pageSize: 15,
//       searchMode: 'manual',
//       initialSearchField: 'itemCode',
//       fixedFields: ['itemCode', 'name', 'barcode', 'unitOfMeasureName'],
//       dynamicFields: selectedInventoryId ? ['quentity', 'reservedQty'] : []
//     });
//     if (res?.row) {
//       setPickedItem(res.row);
//       setItemId(res.row.itemId);
//     }
//   };

//   // ==========================
//   // Filters
//   // ==========================
//   const applyFilters = () => {
//     const operatingUnitId = getOptId(branchFilter);
//     const inventoryId = getOptId(inventoryFilter);

//     dispatch(
//       setReportRequest({
//         reportKey: REPORT_KEY,
//         request: {
//           operatingUnitId: operatingUnitId ?? null,
//           inventoryId: inventoryId ?? null,
//           itemId: itemId ?? null,
//           onlyWithQty: onlyWithQty
//         }
//       })
//     );
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setInventoryFilter(null);
//     clearPickedItem();
//     setOnlyWithQty(true);

//     dispatch(
//       setReportRequest({
//         reportKey: REPORT_KEY,
//         request: {
//           operatingUnitId: null,
//           inventoryId: null,
//           itemId: null,
//           onlyWithQty: true
//         }
//       })
//     );
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   // ==========================
//   // UI helpers
//   // ==========================
//   const getItemName = (r: RowDto) => (isAr ? (r.itemName2 ?? r.itemName) : (r.itemName ?? r.itemName2));
//   const getCategoryName = (r: RowDto) =>
//     isAr ? (r.categoryName2 ?? r.categoryName) : (r.categoryName ?? r.categoryName2);
//   const getInvName = (r: RowDto) => (isAr ? (r.invName2 ?? r.invName) : (r.invName ?? r.invName2));
//   const getOuName = (r: RowDto) => (isAr ? (r.ouName2 ?? r.ouName) : (r.ouName ?? r.ouName2));
//   const getUomName = (r: RowDto) => (isAr ? (r.uomName2 ?? r.uomName) : (r.uomName ?? r.uomName2));

//   // حساب الإجماليات
//   const totals = useMemo(() => {
//     return items.reduce(
//       (acc, row) => {
//         acc.totalQuantity += n0(row.quantity);
//         acc.totalValue += n0(row.total);
//         return acc;
//       },
//       { totalQuantity: 0, totalValue: 0 }
//     );
//   }, [items]);

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center'>
//           {/* ✅ وحدة التشغيل */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-building'></i>
//               </span>
//               <Select
//                 isLoading={loadingOperatingUnitOptions}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OperatingUnitOptions}
//                 placeholder={t('وحدة تشغيـل')}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* ✅ المخزن */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-warehouse'></i>
//               </span>
//               <Select
//                 isLoading={loadingInventoryOptions}
//                 value={inventoryFilter}
//                 onChange={v => {
//                   setInventoryFilter(v);
//                   clearPickedItem();
//                 }}
//                 options={InventoryOptions}
//                 placeholder={t('Inventory')}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* ✅ الصنف (Item Picker) */}
//           <div className='col-lg-4'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-box'></i>
//               </span>
//               <input
//                 className='form-control'
//                 value={getPickedItemLabel(pickedItem)}
//                 placeholder={t('Choose')}
//                 readOnly
//               />
//               <button className='btn btn-outline-theme' type='button' onClick={openItemPicker} title={t('Choose')}>
//                 <i className='fas fa-search'></i>
//               </button>
//               {pickedItem && (
//                 <button
//                   className='btn btn-outline-secondary'
//                   type='button'
//                   onClick={clearPickedItem}
//                   title={t('ClearFilters')}
//                 >
//                   <i className='fas fa-times'></i>
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* ✅ Buttons */}
//           <div className='col-lg-2 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//               disabled={activeFiltersCount === 0}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>
//             <button
//               className='btn btn-theme me-2'
//               type='button'
//               onClick={applyFilters}
//               title={t('ApplyFilters')}
//               disabled={activeFiltersCount === 0}
//             >
//               <i className='fas fa-filter fa-fw'></i>
//             </button>
//             <button
//               className='btn btn-outline-theme me-2'
//               onClick={() => setShowFilters(true)}
//               title={t('SearchFilters')}
//             >
//               <i className='fas fa-sliders-h fa-fw'></i>
//             </button>
//             <button
//               className='btn btn-outline-success me-2'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>

//         {/* ✅ فلتر Only With Qty (جديد) */}
//         <div className='row mt-3'>
//           <div className='col-auto'>
//             <div className='form-check'>
//               <input
//                 className='form-check-input'
//                 type='checkbox'
//                 id='onlyWithQty'
//                 checked={onlyWithQty}
//                 onChange={e => {
//                   setOnlyWithQty(e.target.checked);
//                   //   applyFilters(); // تطبيق تلقائي عند التغيير
//                 }}
//               />
//               <label className='form-check-label' htmlFor='onlyWithQty'>
//                 {isAr ? 'فقط الأصناف ذات الكمية' : 'Only items with quantity'}
//               </label>
//             </div>
//           </div>
//         </div>
//       </CardHeader>

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover mb-0'>
//               <thead className='sticky-top ' style={{ top: 0, zIndex: 10 }}>
//                 <tr
//                   className='bg-theme bg-opacity-35'
//                   style={{
//                     backdropFilter: 'blur(20px)'
//                   }}
//                 >
//                   <th className='small py-3' style={{ minWidth: '250px' }}>
//                     <div className='d-flex align-items-center'>
//                       <span>{t('الصنف')}</span>
//                     </div>
//                   </th>
//                   <th className='small py-3' style={{ minWidth: '200px' }}>
//                     <div className='d-flex align-items-center'>
//                       <span>{t('Category')}</span>
//                     </div>
//                   </th>
//                   <th className='small py-3' style={{ minWidth: '200px' }}>
//                     <div className='d-flex align-items-center'>
//                       <span>{t('المخزن')}</span>
//                     </div>
//                   </th>
//                   <th className='small text-end py-3' style={{ minWidth: '120px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <span>{t('التكلفة')}</span>
//                     </div>
//                   </th>
//                   <th className='small text-end py-3' style={{ minWidth: '100px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <span>{t('Quantity')}</span>
//                     </div>
//                   </th>
//                   <th className='small text-end py-3' style={{ minWidth: '120px' }}>
//                     <div className='d-flex align-items-center justify-content-end'>
//                       <i className='fas fa-calculator text-theme me-2'></i>
//                       <span>{t('Total')}</span>
//                     </div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => (
//                     <tr key={`${r.itemId}-${r.invId}-${idx}`} className='align-middle'>
//                       {/* عمود الصنف والوحدة مدمجين */}
//                       <td>
//                         <div className='d-flex flex-column'>
//                           <div className='d-flex align-items-center'>
//                             <div className='bg-theme bg-opacity-10 rounded p-2 me-2'>
//                               <i className='fas fa-box text-theme'></i>
//                             </div>
//                             <div>
//                               <div className='fw-bold text-theme'>{safe(getItemName(r))}</div>
//                               <div className='d-flex align-items-center gap-2 mt-1'>
//                                 <span className='badge bg-light text-dark px-2 py-1'>
//                                   <i className='fas fa-barcode me-1' style={{ fontSize: '10px' }}></i>
//                                   {safe(r.itemCode)}
//                                 </span>
//                                 <span className='badge bg-theme text-white px-2 py-1'>
//                                   <i className='fas fa-ruler me-1' style={{ fontSize: '10px' }}></i>
//                                   {safe(getUomName(r))}
//                                 </span>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                       {/* عمود التصنيف */}
//                       <td>
//                         <div className='d-flex align-items-center'>
//                           <span className='fw-medium'>{safe(getCategoryName(r))}</span>
//                         </div>
//                       </td>
//                       {/* عمود الموقع (مخزن + وحدة تشغيل) */}
//                       <td>
//                         <div className='d-flex flex-column gap-1'>
//                           <div className='d-flex align-items-center'>
//                             <i className='fas fa-warehouse text-secondary me-2' style={{ width: '16px' }}></i>
//                             <span>{safe(getInvName(r))}</span>
//                           </div>
//                           <div className='d-flex align-items-center'>
//                             <i className='fas fa-building text-secondary me-2' style={{ width: '16px' }}></i>
//                             <small className='text-muted'>{safe(getOuName(r))}</small>
//                           </div>
//                         </div>
//                       </td>
//                       {/* عمود التكلفة */}
//                       <td className='text-end'>
//                         <div className='fw-bold'>{formatNumber(n0(r.costPrice))}</div>
//                         {r.avgCostPrice !== null && (
//                           <small className='text-muted d-block'>
//                             {t('Avg')}: {formatNumber(r.avgCostPrice)}
//                           </small>
//                         )}
//                       </td>
//                       {/* عمود الكمية */}
//                       <td className='text-end'>
//                         <div className='fw-bold'>{formatNumber(n0(r.quantity), 0)}</div>
//                         {r.avgCostSimple !== null && (
//                           <small className='text-muted d-block'>
//                             {t('Avg Simple')}: {formatNumber(r.avgCostSimple)}
//                           </small>
//                         )}
//                       </td>
//                       {/* عمود الإجمالي */}
//                       <td className='text-end'>
//                         <div className='fw-bold text-success'>{formatNumber(n0(r.total))}</div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={6} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-inbox fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                         <small>{t('TryChangingFilters')}</small>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//               {/* تذييل الجدول مع الإجماليات */}
//               {!loading && items.length > 0 && (
//                 <tfoot className=' fw-bold'>
//                   <tr>
//                     <td colSpan={4} className='text-end'>
//                       {t('Total')}:
//                     </td>
//                     <td className='text-end'>{formatNumber(totals.totalQuantity, 0)}</td>
//                     <td className='text-end text-success'>{formatNumber(totals.totalValue)}</td>
//                   </tr>
//                 </tfoot>
//               )}
//             </table>
//           </div>
//         </Loading>
//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       {showFilters ? null : null}
//       <ItemUomPickerModal {...modalProps} />
//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'تقييم المخزون' : 'Inventory Valuation')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default RPT_InventoryValuation;

import Select from 'react-select';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useAppDispatch, useAppSelector } from '@store/hooks';
// ✅ السلايس
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
// ✅ المكونات
// import ReportPagination from './ReportPagination';
// ✅ Hooks الخيارات
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// ✅ Item/UOM Picker
import { useItemUomPicker, ItemUomPickerModal } from '@pages/INV/lookups/useItemUomPicker';
import type { ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';
import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';
import ReportSearchFiltersModal, { type ReportFilterField } from '@Helper/ReportPaged/ReportSearchFiltersModal';
// import ReportExportExcelModal, { type ExportColumn } from './ReportExportExcelModal';

// import ReportSearchFiltersModal, { type ReportFilterField } from './ReportSearchFiltersModal';

type ReportRequestDto = {
  pageIndex?: number;
  pageSize?: number;
  sortBy?: string | null;
  sortDir?: string | null;

  aggregateLevel?: string | null;
  includeTotalRows?: boolean;

  inventoryType?: string | null;

  itemId?: string | null;
  itemCode?: string | null;
  itemType?: string | null;
  taxCategory?: string | null;
  itemName?: string | null;

  categoryId?: string | null;
  brandId?: string | null;
  uomId?: string | null;
  uomClass?: string | null;

  inventoryId?: string | null;
  operatingUnitId?: string | null;

  minQty?: number | null;
  maxQty?: number | null;
  minCost?: number | null;
  maxCost?: number | null;

  onlyWithQty?: boolean;

  // CSV
  itemIds?: string | null;
  categoryIds?: string | null;
  brandIds?: string | null;
  inventoryIds?: string | null;
  operatingUnitIds?: string | null;
};

const advancedFields: ReportFilterField<ReportRequestDto>[] = [
  {
    name: 'includeTotalRows',
    labelAr: 'إرجاع إجمالي السطور',
    labelEn: 'Include Total Rows',
    type: 'checkbox',
    defaultValue: true,
    col: 6
  },
  {
    name: 'aggregateLevel',
    labelAr: 'مستوى التجميع',
    labelEn: 'Aggregate Level',
    type: 'select',
    col: 6,
    options: [
      { value: 'DETAIL', labelAr: 'تفصيلي', labelEn: 'Detail' },
      { value: 'ITEM', labelAr: 'حسب الصنف', labelEn: 'By Item' },
      { value: 'ITEM_INV', labelAr: 'حسب الصنف/المخزن', labelEn: 'By Item/Inventory' },
      { value: 'CATEGORY', labelAr: 'حسب التصنيف', labelEn: 'By Category' }
    ],
    getOptionLabel: (o, ctx) => (ctx.isAr ? o.labelAr : o.labelEn),
    getOptionValue: o => String(o.value),
    mapOut: opt => (opt ? String(opt.value) : null),
    mapIn: raw =>
      raw
        ? [{ value: 'DETAIL' }, { value: 'ITEM' }, { value: 'ITEM_INV' }, { value: 'CATEGORY' }]
            .map(x => x.value)
            .includes(String(raw))
          ? [
              { value: 'DETAIL', labelAr: 'تفصيلي', labelEn: 'Detail' },
              { value: 'ITEM', labelAr: 'حسب الصنف', labelEn: 'By Item' },
              { value: 'ITEM_INV', labelAr: 'حسب الصنف/المخزن', labelEn: 'By Item/Inventory' },
              { value: 'CATEGORY', labelAr: 'حسب التصنيف', labelEn: 'By Category' }
            ].find(x => x.value === String(raw))
          : null
        : null,
    defaultValue: 'DETAIL'
  },
  {
    name: 'inventoryType',
    labelAr: 'نوع المخزون',
    labelEn: 'Inventory Type',
    type: 'text',
    placeholderAr: 'مثال: 130',
    placeholderEn: 'e.g. 130',
    col: 6,
    normalize: v => (String(v ?? '').trim() === '' ? null : String(v).trim())
  },

  // Item filters
  {
    name: 'itemCode',
    labelAr: 'كود الصنف',
    labelEn: 'Item Code',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'itemName',
    labelAr: 'اسم الصنف',
    labelEn: 'Item Name',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'itemType',
    labelAr: 'نوع الصنف',
    labelEn: 'Item Type',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'taxCategory',
    labelAr: 'فئة الضريبة',
    labelEn: 'Tax Category',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },

  // Dimension IDs (دخلها كنص GUID حالياً)
  {
    name: 'categoryId',
    labelAr: 'Category Id',
    labelEn: 'Category Id',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'brandId',
    labelAr: 'Brand Id',
    labelEn: 'Brand Id',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'uomId',
    labelAr: 'UOM Id',
    labelEn: 'UOM Id',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'uomClass',
    labelAr: 'UOM Class',
    labelEn: 'UOM Class',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },

  // Ranges
  {
    name: 'minQty',
    labelAr: 'أقل كمية',
    labelEn: 'Min Qty',
    type: 'number',
    col: 6,
    defaultValue: null
  },
  {
    name: 'maxQty',
    labelAr: 'أعلى كمية',
    labelEn: 'Max Qty',
    type: 'number',
    col: 6,
    defaultValue: null
  },
  {
    name: 'minCost',
    labelAr: 'أقل تكلفة',
    labelEn: 'Min Cost',
    type: 'number',
    col: 6,
    defaultValue: null
  },
  {
    name: 'maxCost',
    labelAr: 'أعلى تكلفة',
    labelEn: 'Max Cost',
    type: 'number',
    col: 6,
    defaultValue: null
  },

  // Sorting
  {
    name: 'sortBy',
    labelAr: 'Sort By',
    labelEn: 'Sort By',
    type: 'text',
    col: 6,
    normalize: v => String(v ?? '').trim() || null
  },
  {
    name: 'sortDir',
    labelAr: 'اتجاه الترتيب',
    labelEn: 'Sort Direction',
    type: 'select',
    col: 6,
    options: [
      { value: 'ASC', labelAr: 'تصاعدي', labelEn: 'ASC' },
      { value: 'DESC', labelAr: 'تنازلي', labelEn: 'DESC' }
    ],
    getOptionLabel: (o, ctx) => (ctx.isAr ? o.labelAr : o.labelEn),
    getOptionValue: o => String(o.value),
    mapOut: opt => (opt ? String(opt.value) : null),
    mapIn: raw =>
      raw
        ? [
            { value: 'ASC', labelAr: 'تصاعدي', labelEn: 'ASC' },
            { value: 'DESC', labelAr: 'تنازلي', labelEn: 'DESC' }
          ].find(x => x.value === String(raw).toUpperCase())
        : null,
    defaultValue: null
  },

  // CSV multi-ids as tags
  {
    name: 'itemIds',
    labelAr: 'Item Ids (CSV)',
    labelEn: 'Item Ids (CSV)',
    type: 'tags',
    col: 12,
    defaultValue: null
  },
  {
    name: 'categoryIds',
    labelAr: 'Category Ids (CSV)',
    labelEn: 'Category Ids (CSV)',
    type: 'tags',
    col: 12,
    defaultValue: null
  },
  {
    name: 'brandIds',
    labelAr: 'Brand Ids (CSV)',
    labelEn: 'Brand Ids (CSV)',
    type: 'tags',
    col: 12,
    defaultValue: null
  },
  {
    name: 'inventoryIds',
    labelAr: 'Inventory Ids (CSV)',
    labelEn: 'Inventory Ids (CSV)',
    type: 'tags',
    col: 12,
    defaultValue: null
  },
  {
    name: 'operatingUnitIds',
    labelAr: 'OperatingUnit Ids (CSV)',
    labelEn: 'OperatingUnit Ids (CSV)',
    type: 'tags',
    col: 12,
    defaultValue: null
  }
];

type RowDto = {
  itemId: string;
  itemCode: string;
  itemType: string;
  taxCtegory: string;
  itemName: string;
  itemName2: string;
  categoryId: string;
  categoryName: string;
  categoryName2: string;
  uomId: string;
  uomCode: string;
  uomName: string;
  uomName2: string;
  uomClass: string;
  brandId: string | null;
  brandName: string | null;
  brandName2: string | null;
  invId: string;
  invCode: string;
  invName: string;
  invName2: string;
  ouId: string;
  ouCode: string;
  ouName: string;
  ouName2: string;
  costPrice: number;
  quantity: number;
  total: number;
  avgCostSimple: number | null;
  avgCostPrice: number | null;
};

const REPORT_KEY = 'RPT_InventoryValuation';
const ENDPOINT = 'InventoryReports/GetInventoryValuationPaged';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));
const n0 = (v: any) => (v === null || v === undefined || Number.isNaN(Number(v)) ? 0 : Number(v));
const formatNumber = (num: number, digits: number = 2) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(num);
};
const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const RPT_InventoryValuation = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  // options
  const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInventoryOptions } = useGetInventoryWithPermission();

  // ✅ Item & UOM Picker
  const { pickItemUom, modalProps } = useItemUomPicker();
  const [pickedItem, setPickedItem] = useState<ItemWithUomRow | null>(null);
  const [itemId, setItemId] = useState<string | null>(null);

  // ✅ فلتر Only With Qty (جديد)
  const [onlyWithQty, setOnlyWithQty] = useState<boolean>(true);

  // Export Excel
  const [showExport, setShowExport] = useState(false);

  const exportColumns: ExportColumn<RowDto>[] = [
    {
      headerAr: 'الصنف',
      headerEn: 'Item',
      value: (r, ctx) => (ctx.isAr ? (r.itemName2 ?? r.itemName) : (r.itemName ?? r.itemName2))
    },
    { headerAr: 'الكود', headerEn: 'Code', value: r => r.itemCode ?? '' },
    {
      headerAr: 'التصنيف',
      headerEn: 'Category',
      value: (r, ctx) => (ctx.isAr ? (r.categoryName2 ?? r.categoryName) : (r.categoryName ?? r.categoryName2))
    },
    {
      headerAr: 'الوحدة',
      headerEn: 'UOM',
      value: (r, ctx) => (ctx.isAr ? (r.uomName2 ?? r.uomName) : (r.uomName ?? r.uomName2))
    },
    {
      headerAr: 'المخزن',
      headerEn: 'Inventory',
      value: (r, ctx) => (ctx.isAr ? (r.invName2 ?? r.invName) : (r.invName ?? r.invName2))
    },
    {
      headerAr: 'وحدة التشغيل',
      headerEn: 'Operating Unit',
      value: (r, ctx) => (ctx.isAr ? (r.ouName2 ?? r.ouName) : (r.ouName ?? r.ouName2))
    },
    { headerAr: 'التكلفة', headerEn: 'Cost', value: r => r.costPrice ?? 0 },
    { headerAr: 'الكمية', headerEn: 'Qty', value: r => r.quantity ?? 0 },
    { headerAr: 'الإجمالي', headerEn: 'Total', value: r => r.total ?? 0 }
  ];

  // local filters UI state
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [inventoryFilter, setInventoryFilter] = useState<any>(null);
  const [showFilters, setShowFilters] = useState(false);

  const selectedInventoryId = useMemo(() => getOptId(inventoryFilter), [inventoryFilter]);

  // report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;
  const isAr = i18n.language !== 'en';

  const activeFiltersCount = useMemo(() => {
    let c = 0;
    if (branchFilter) c++;
    if (inventoryFilter) c++;
    if (itemId) c++;
    if (!onlyWithQty) c++; // إذا تم إلغاء التحديد = فلتر نشط (عرض الأصناف بدون كمية)
    return c;
  }, [branchFilter, inventoryFilter, itemId, onlyWithQty]);

  useEffect(() => {
    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest: {
          pageIndex: 0,
          pageSize: 50,
          onlyWithQty: true
        }
      })
    );
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  }, [dispatch]);

  // ==========================
  // Item Picker helpers
  // ==========================
  const getPickedItemLabel = (r: ItemWithUomRow | null) => {
    if (!r) return '';
    const name = isAr ? r.name2 || r.name : r.name || r.name2;
    const code = r.itemCode ?? '';
    return `${code} - ${name ?? ''}`.trim();
  };

  const clearPickedItem = () => {
    setPickedItem(null);
    setItemId(null);
  };

  const openItemPicker = async () => {
    const res = await pickItemUom({
      title: isAr ? 'اختيار صنف ووحدة' : 'Select Item & UOM',
      params: {
        InventoryId: selectedInventoryId || undefined,
        WithParent: true,
        WithImage: false,
        WithLots: false,
        OnlyEnabled: true
      } as any,
      pageSize: 15,
      searchMode: 'manual',
      initialSearchField: 'itemCode',
      fixedFields: ['itemCode', 'name', 'barcode', 'unitOfMeasureName'],
      dynamicFields: selectedInventoryId ? ['quentity', 'reservedQty'] : []
    });
    if (res?.row) {
      setPickedItem(res.row);
      setItemId(res.row.itemId);
    }
  };

  // ==========================
  // Filters
  // ==========================
  // const applyFilters = () => {
  //   const operatingUnitId = getOptId(branchFilter);
  //   const inventoryId = getOptId(inventoryFilter);

  //   dispatch(
  //     setReportRequest({
  //       reportKey: REPORT_KEY,
  //       request: {
  //         operatingUnitId: operatingUnitId ?? null,
  //         inventoryId: inventoryId ?? null,
  //         itemId: itemId ?? null,
  //         onlyWithQty: onlyWithQty
  //       }
  //     })
  //   );
  //   dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  // };

  const applyFilters = () => {
    const operatingUnitId = getOptId(branchFilter);
    const inventoryId = getOptId(inventoryFilter);

    const prevReq = ((report as any)?.request ?? {}) as any;

    const nextReq = {
      ...prevReq,
      pageIndex: 0,
      operatingUnitId: operatingUnitId ?? null,
      inventoryId: inventoryId ?? null,
      itemId: itemId ?? null,
      onlyWithQty: onlyWithQty
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextReq }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  // const clearFilters = () => {
  //   setBranchFilter(null);
  //   setInventoryFilter(null);
  //   clearPickedItem();
  //   setOnlyWithQty(true);

  //   dispatch(
  //     setReportRequest({
  //       reportKey: REPORT_KEY,
  //       request: {
  //         operatingUnitId: null,
  //         inventoryId: null,
  //         itemId: null,
  //         onlyWithQty: true
  //       }
  //     })
  //   );
  //   dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  // };

  // ==========================
  // UI helpers
  // ==========================

  const clearFilters = () => {
    setBranchFilter(null);
    setInventoryFilter(null);
    clearPickedItem();
    setOnlyWithQty(true);

    const resetReq: Partial<ReportRequestDto> = {
      pageIndex: 0,
      pageSize: 50,
      onlyWithQty: true,
      includeTotalRows: true,

      operatingUnitId: null,
      inventoryId: null,
      itemId: null,

      aggregateLevel: 'DETAIL',
      inventoryType: null,

      itemCode: null,
      itemType: null,
      taxCategory: null,
      itemName: null,

      categoryId: null,
      brandId: null,
      uomId: null,
      uomClass: null,

      minQty: null,
      maxQty: null,
      minCost: null,
      maxCost: null,

      sortBy: null,
      sortDir: null,

      itemIds: null,
      categoryIds: null,
      brandIds: null,
      inventoryIds: null,
      operatingUnitIds: null
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const getItemName = (r: RowDto) => (isAr ? (r.itemName2 ?? r.itemName) : (r.itemName ?? r.itemName2));
  const getCategoryName = (r: RowDto) =>
    isAr ? (r.categoryName2 ?? r.categoryName) : (r.categoryName ?? r.categoryName2);
  const getInvName = (r: RowDto) => (isAr ? (r.invName2 ?? r.invName) : (r.invName ?? r.invName2));
  const getOuName = (r: RowDto) => (isAr ? (r.ouName2 ?? r.ouName) : (r.ouName ?? r.ouName2));
  const getUomName = (r: RowDto) => (isAr ? (r.uomName2 ?? r.uomName) : (r.uomName ?? r.uomName2));

  // حساب الإجماليات
  const totals = useMemo(() => {
    return items.reduce(
      (acc, row) => {
        acc.totalQuantity += n0(row.quantity);
        acc.totalValue += n0(row.total);
        return acc;
      },
      { totalQuantity: 0, totalValue: 0 }
    );
  }, [items]);

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center'>
          {/* ✅ وحدة التشغيل */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-building'></i>
              </span>
              <Select
                isLoading={loadingOperatingUnitOptions}
                value={branchFilter}
                onChange={setBranchFilter}
                options={OperatingUnitOptions}
                placeholder={t('وحدة تشغيـل')}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* ✅ المخزن */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-warehouse'></i>
              </span>
              <Select
                isLoading={loadingInventoryOptions}
                value={inventoryFilter}
                onChange={v => {
                  setInventoryFilter(v);
                  clearPickedItem();
                }}
                options={InventoryOptions}
                placeholder={t('Inventory')}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* ✅ الصنف (Item Picker) */}
          <div className='col-lg-4'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-box'></i>
              </span>
              <input
                className='form-control'
                value={getPickedItemLabel(pickedItem)}
                placeholder={t('Choose')}
                readOnly
              />
              <button className='btn btn-outline-theme' type='button' onClick={openItemPicker} title={t('Choose')}>
                <i className='fas fa-search'></i>
              </button>
              {pickedItem && (
                <button
                  className='btn btn-outline-secondary'
                  type='button'
                  onClick={clearPickedItem}
                  title={t('ClearFilters')}
                >
                  <i className='fas fa-times'></i>
                </button>
              )}
            </div>
          </div>

          {/* ✅ Buttons */}
          <div className='col-lg-2 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
              disabled={activeFiltersCount === 0}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
            <button
              className='btn btn-theme me-2'
              type='button'
              onClick={applyFilters}
              title={t('ApplyFilters')}
              disabled={activeFiltersCount === 0}
            >
              <i className='fas fa-filter fa-fw'></i>
            </button>
            {/* <button
              className='btn btn-outline-theme me-2'
              onClick={() => setShowFilters(true)}
              title={t('SearchFilters')}
            >
              <i className='fas fa-sliders-h fa-fw'></i>
            </button> */}
            <button
              className='btn btn-outline-success me-2'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>

        {/* ✅ فلتر Only With Qty (جديد) */}
        <div className='row mt-3'>
          <div className='col-auto'>
            <div className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                id='onlyWithQty'
                checked={onlyWithQty}
                onChange={e => {
                  setOnlyWithQty(e.target.checked);
                  //   applyFilters(); // تطبيق تلقائي عند التغيير
                }}
              />
              <label className='form-check-label' htmlFor='onlyWithQty'>
                {isAr ? 'فقط الأصناف ذات الكمية' : 'Only items with quantity'}
              </label>
            </div>
          </div>
        </div>
      </CardHeader>

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover mb-0'>
              <thead className='sticky-top ' style={{ top: 0, zIndex: 10 }}>
                <tr
                  className='bg-theme bg-opacity-35'
                  style={{
                    backdropFilter: 'blur(20px)'
                  }}
                >
                  <th className='small py-3' style={{ minWidth: '250px' }}>
                    <div className='d-flex align-items-center'>
                      <span>{t('الصنف')}</span>
                    </div>
                  </th>
                  <th className='small py-3' style={{ minWidth: '200px' }}>
                    <div className='d-flex align-items-center'>
                      <span>{t('Category')}</span>
                    </div>
                  </th>
                  <th className='small py-3' style={{ minWidth: '200px' }}>
                    <div className='d-flex align-items-center'>
                      <span>{t('المخزن')}</span>
                    </div>
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: '120px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                      <span>{t('التكلفة')}</span>
                    </div>
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: '100px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                      <span>{t('Quantity')}</span>
                    </div>
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: '120px' }}>
                    <div className='d-flex align-items-center justify-content-end'>
                      <i className='fas fa-calculator text-theme me-2'></i>
                      <span>{t('Total')}</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => (
                    <tr key={`${r.itemId}-${r.invId}-${idx}`} className='align-middle'>
                      {/* عمود الصنف والوحدة مدمجين */}
                      <td>
                        <div className='d-flex flex-column'>
                          <div className='d-flex align-items-center'>
                            <div className='bg-theme bg-opacity-10 rounded p-2 me-2'>
                              <i className='fas fa-box text-theme'></i>
                            </div>
                            <div>
                              <div className='fw-bold text-theme'>{safe(getItemName(r))}</div>
                              <div className='d-flex align-items-center gap-2 mt-1'>
                                <span className='badge bg-light text-dark px-2 py-1'>
                                  <i className='fas fa-barcode me-1' style={{ fontSize: '10px' }}></i>
                                  {safe(r.itemCode)}
                                </span>
                                <span className='badge bg-theme text-white px-2 py-1'>
                                  <i className='fas fa-ruler me-1' style={{ fontSize: '10px' }}></i>
                                  {safe(getUomName(r))}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      {/* عمود التصنيف */}
                      <td>
                        <div className='d-flex align-items-center'>
                          <span className='fw-medium'>{safe(getCategoryName(r))}</span>
                        </div>
                      </td>
                      {/* عمود الموقع (مخزن + وحدة تشغيل) */}
                      <td>
                        <div className='d-flex flex-column gap-1'>
                          <div className='d-flex align-items-center'>
                            <i className='fas fa-warehouse text-secondary me-2' style={{ width: '16px' }}></i>
                            <span>{safe(getInvName(r))}</span>
                          </div>
                          <div className='d-flex align-items-center'>
                            <i className='fas fa-building text-secondary me-2' style={{ width: '16px' }}></i>
                            <small className='text-muted'>{safe(getOuName(r))}</small>
                          </div>
                        </div>
                      </td>
                      {/* عمود التكلفة */}
                      <td className='text-end'>
                        <div className='fw-bold'>{formatNumber(n0(r.costPrice))}</div>
                        {r.avgCostPrice !== null && (
                          <small className='text-muted d-block'>
                            {t('Avg')}: {formatNumber(r.avgCostPrice)}
                          </small>
                        )}
                      </td>
                      {/* عمود الكمية */}
                      <td className='text-end'>
                        <div className='fw-bold'>{formatNumber(n0(r.quantity), 0)}</div>
                        {r.avgCostSimple !== null && (
                          <small className='text-muted d-block'>
                            {t('Avg Simple')}: {formatNumber(r.avgCostSimple)}
                          </small>
                        )}
                      </td>
                      {/* عمود الإجمالي */}
                      <td className='text-end'>
                        <div className='fw-bold text-success'>{formatNumber(n0(r.total))}</div>
                      </td>
                    </tr>
                  ))
                ) : !loading ? (
                  <tr>
                    <td colSpan={6} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                        <small>{t('TryChangingFilters')}</small>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
              {/* تذييل الجدول مع الإجماليات */}
              {!loading && items.length > 0 && (
                <tfoot className=' fw-bold'>
                  <tr>
                    <td colSpan={4} className='text-end'>
                      {t('Total')}:
                    </td>
                    <td className='text-end'>{formatNumber(totals.totalQuantity, 0)}</td>
                    <td className='text-end text-success'>{formatNumber(totals.totalValue)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Loading>
        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      {showFilters ? null : null}
      <ItemUomPickerModal {...modalProps} />
      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'تقييم المخزون' : 'Inventory Valuation')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />

      <ReportSearchFiltersModal<ReportRequestDto>
        show={showFilters}
        onHide={() => setShowFilters(false)}
        value={((report as any)?.request ?? {}) as Partial<ReportRequestDto>}
        fields={advancedFields}
        title={{ ar: 'فلاتر البحث المتقدمة', en: 'Advanced Search Filters' }}
        onApply={patch => {
          const prevReq = ((report as any)?.request ?? {}) as any;

          const nextReq = {
            ...prevReq,
            ...patch,
            pageIndex: 0
          };

          dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextReq }));
          dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
        }}
      />
    </>
  );
};

export default RPT_InventoryValuation;
